import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import dayjs from 'dayjs';

const ResumeBeachCleaning = ({
    info,
    participants,
    residuesCollected,
    photographicRecords
}) => {
	const safeParticipants = Array.isArray(participants) ? participants : [];
	const safeResiduesCollected = Array.isArray(residuesCollected) ? residuesCollected : [];
	const safePhotographicRecords = Array.isArray(photographicRecords) ? photographicRecords : [];

    const formatNumber = (number, totalItems) => {
        const totalDigits = totalItems.toString().length;
        return number.toString().padStart(totalDigits, '0');
    };

    const formatDate = (dateString) => {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', options).split('/').join('-');
    };

    return (
        <Row className="justify-content-center">
            <Col xxl={12}>
            <Card id="demo" className='border-1'>
                <Row>
                    <Col lg={12}>
                        <h5 className='fw-bold text-decoration-underline text-uppercase m-0 p-3 text-center'>
                            Resumen de Limpieza de Playa
                        </h5>
                        <CardBody className="p-3 border-top border-top-dashed">
                            <h5 className='pb-2'>Datos Generales</h5>
                            <Row className="g-3">
                                <Col md={3}>
                                    <div className="fw-bold tx-descripcion">Establecimiento:</div>
                                    <div className='px-2'>{(info?.sector?.establishment?.name || '-')}</div>
                                </Col>
                                <Col md={3}>
                                    <div className="fw-bold tx-descripcion">Sector:</div>
                                    <div className='px-2'>{info?.sector?.name || '-'}</div>
                                </Col>
                                <Col md={3}>
                                    <div className="fw-bold tx-descripcion">Fecha:</div>
                                    <div className='px-2'>{(info?.date ? dayjs(info?.date).format('DD-MM-YYYY') : '-')}</div>
                                </Col>
                                <Col md={3}>
                                    <div className="fw-bold tx-descripcion">¿Limpieza Realizada?:</div>
                                    <div className='px-2'>{((info?.is_done ? 'Sí' : 'No' ) || '-')}</div>
                                </Col>
                                <Col md={3}>
                                    <div className="fw-bold tx-descripcion">Motivo:</div>
                                    <div className='px-2'>{info?.beach_cleaning_reason?.name || '-'}</div>
                                </Col>
                                <Col md={3}>
                                    <div className="fw-bold tx-descripcion">Kilometros recorridos:</div>
                                    <div className='px-2'>{(info?.kilometers_traveled || '-')}</div>
                                </Col>
                                <Col md={12}>
                                    <div className="fw-bold tx-descripcion">Observaciones:</div>
                                    <p className='tx-descripcion mb-0'>{(info?.observation || '-')}</p>
                                </Col>
                            </Row>
                        </CardBody>
                    </Col>
                    <Col lg={12}>
                        <div className="border-top mt-2">
                        </div>
                        <div className="table-responsive p-3">
                            <h5 className='pb-2'>Participantes</h5>
                            <div className="table-responsive">
                                <table className="table table-borderless text-center table-nowrap align-middle mb-0">
                                    <thead>
                                    <tr className="table-active">
                                        <th scope="col">#</th>
                                        <th scope="col">Nombre</th>
                                        <th scope="col">¿Es externo?</th>
                                        <th scope="col">Empresa o institución</th>
                                        <th scope="col">¿Es responsable?</th>
                                    </tr>
                                    </thead>
                                    <tbody className="products-list">
                                        {safeParticipants.map((item, index) => (
                                            <tr key={index}>
                                                <td scope="row">{formatNumber(index + 1, safeParticipants.length || 1)}</td>
                                                <td>
                                                    <span className="fw-semibold">{item?.person?.name}</span>
                                                    {/* <p className="text-muted mb-0">{item.category}</p> */}
                                                </td>
                                                <td>{(item.external ? 'Sí' : 'No')}</td>
                                                <td>{(item.organization)}</td>
                                                <td>{(item.responsible ? 'Sí' : 'No')}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="border-top mt-2">
                        </div>
                        <div className="table-responsive p-3">
                            <h5 className='pb-2'>Residuos Recolectados</h5>
                            <div className="table-responsive">
                                <table className="table table-borderless text-center table-nowrap align-middle mb-0">
                                    <thead>
                                    <tr className="table-active">
                                        <th scope="col">#</th>
                                        <th scope="col">Residuo</th>
                                        <th scope="col">Cantidad (kg)</th>
                                        <th scope="col">Tipo de origen</th>
                                    </tr>
                                    </thead>
                                    <tbody className="products-list">
                                        {safeResiduesCollected.map((item, index) => (
                                            <tr key={index}>
                                                <td scope="row">{formatNumber(index + 1, safeResiduesCollected.length || 1)}</td>
                                                <td>
                                                    <span className="fw-semibold">{item?.residue?.name}</span>
                                                    {/* <p className="text-muted mb-0">{item.residue.residue_type.name}</p> */}
                                                </td>
                                                <td>{item.kilograms}</td>
                                                <td>{item?.origin_type?.name}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="border-top mt-2">
                        </div>
                        <div className="table-responsive p-3">
                            <h5 className='pb-2'>Registros Fotográficos</h5>
                            <div className="table-responsive">
                                <table className="table table-borderless text-center table-nowrap align-middle mb-0">
                                    <thead>
                                    <tr className="table-active">
                                        <th scope="col">#</th>
                                        <th scope="col">Nombre</th>
                                        <th scope="col">Tipo de registro</th>
                                        <th scope="col">Latitud</th>
                                        <th scope="col">Longitud</th>
                                    </tr>
                                    </thead>
                                    <tbody className="products-list">
                                        {safePhotographicRecords.map((item, index) => (
                                            <tr key={index}>
                                                <td scope="row">{formatNumber(index + 1, safePhotographicRecords.length || 1)}</td>
                                                <td>
                                                    <span className="fw-semibold">{(
                                                        (Array.isArray(item?.document) && item?.document.length)
                                                            ?
                                                            (
                                                                item.document[0].filename +
                                                                item.document[0].extension
                                                            )
                                                            :
                                                            item.document?.name || ''
                                                    )}</span>
                                                </td>
                                                <td>{item?.record_type?.name}</td>
                                                <td>{(item?.latitude ? item.latitude : '-')}</td>
                                                <td>{(item?.longitude ? item.longitude : '-')}</td>
                                                {/* <td>{item.amount} {item.unit_measurement}</td>
                                                <td>{item.kilograms_total} Kg</td>
                                                <td className="text-end">$1</td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Card>
            </Col>
        </Row>
    );
};

export default ResumeBeachCleaning;
